import {AuthenticateDialog}	from "dialog";
import template				from "../html/myauthenticatedialog.html";
import css					from "../css/myauthenticatedialog.css";

class MyAuthenticateDialog extends AuthenticateDialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-myauthenticatedialog", MyAuthenticateDialog);
	}
	constructor() {
		super();
		
		this.show();
	}
	onauthenticate(event) {
		server.rcall("RM_login", this.username, this.password).then(function(result) {
			this.close();

			var event = new CustomEvent('authenticated', {
				detail: {
					username: this.username
				}
			});
			application.dispatchEvent(event);

			if (typeof this.onauthenticated == "function")
				application.onauthenticated(event);

		}.bind(this)).catch(function(result) {
			alert("login failed");
		}.bind(this));
	}
	onabort(event) {
		this.close();
		//application.close();
	}
}

MyAuthenticateDialog.constructor();

export default MyAuthenticateDialog;